define('modules/overview/overview_view',[
  'backbone',
  'jquery',
  '_',
  'URIjs/URI',
  './overview_collection',

  './view_player_loop_model',
  './view_player_loop_modal',

  './player_preview_option_model',
  './player_preview_option_modal',

  'modules/list/list_view',
  'modules/loading/loading_spinner_view',
  'modules/modal/modal_view',

  'text!./overview_template.html',
  'text!./overview_header_template.html',
  'text!./overview_list_item_template.html',
  'session'
], function (Backbone, $, _,
  URI,
  OverviewCollection ,
  ViewPlayerLoopModel,
  ViewPlayerLoopModal,
  PlayerPreviewOptionModel,
  PlayerPreviewOptionModal,
  ListView,
  Loading,
  ModalView,
  overview_template,
  overview_header_template,
  overview_list_item_template,
  session) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {

      _.extend(this, opts);

      this.collection = false;
      this.subViews = [];

      this.render();

      var loading = new Loading();
      this.subViews.push(loading);

      this.collection = OverviewCollection;
      this.collection.params = _.extend(this.collection.params, { location_id: session.get('location_id') });

      this.listenTo(this.collection, 'request', loading.start.bind(loading));

      this.listenTo(this.collection, 'sync', function (collection) {
        loading.done();
        this.renderHeader();
        this.renderList();
      }, this);

      this.collection.params = _.extend(this.collection.params, URI.parseQuery(this.params));
      this.collection.fetch();
    },

    hasSidebar: false,
    subViews: [],

    template: _.template(overview_template),
    header_template: _.template(overview_header_template),
    item_template: _.template(overview_list_item_template),

    events: {
      'mouseover .overview-items': 'mouseoverPlayer',
      'mouseout .overview-items': 'mouseoutPlayer',
      'click .js-preview-loop': 'openPlayerPreviewOptionsModal'
    },

    render: function () {
      this.$el.html(this.template());
      return this;
    },

    renderHeader: function () {
      this.$('.js-players-header').html(this.header_template(this.collection.params));
      return this;
    },

    renderList: function () {
      var items = [], playerList;
      this.collection.each(function (model) {
        items.push({ value: this.item_template(model.toJSON()) });
      }, this);

      playerList = new ListView({
        items: items,
        className: 'list players-list'
      });

      this.$('.js-players-list').html(playerList.$el);

      this.subViews.push(playerList);

      return this;
    },

    mouseoverPlayer: function (e) {
      var player_id = $(e.currentTarget).data('id');
      this.$el.parent().find('img[data-id="' + player_id + '"]:first').trigger('mouseover');
    },

    mouseoutPlayer: function (e) {
      var player_id = $(e.currentTarget).data('id');
      this.$el.parent().find('img[data-id="' + player_id + '"]:first').trigger('mouseout');
    },

    openPlayerPreviewOptionsModal: function (e) {
      e.preventDefault();
      var elem = $(e.currentTarget).parent().parent();
      var playerId = parseInt(elem.data('id'));
      var playerName = elem.find('.overview-list-item--name').data('playername');
      var zoneName = elem.find('.overview-list-item--zone').data('zonetitle');
      var openPreviewLoopModalRef = this.openPreviewLoopModal.bind(this);

      var modalView = new ModalView({
        title: _.t('previewmodal.header') + playerName,
        modalContent: new PlayerPreviewOptionModal({
          playerId: playerId,
          playerName: playerName,
          zoneName: zoneName,
          openPreviewLoopModalRef: openPreviewLoopModalRef
        }),
        bottom_toolbar: false
      });
      modalView.subViews.push(modalView.modal);
      modalView.open();
    },

    openPreviewLoopModal: function (selectedPlayerId, selectedPlayerName, selectedDate, selectedTime) {
      var viewPlayerLoopModel = new ViewPlayerLoopModel();
      viewPlayerLoopModel.playerId = selectedPlayerId;
      viewPlayerLoopModel.playerName = selectedPlayerName;
      viewPlayerLoopModel.date = selectedDate;
      viewPlayerLoopModel.time = selectedTime;

      var loading = new Loading();
      this.subViews.push(loading);

      viewPlayerLoopModel.fetch().then(function (data) {
        console.log(data);
        loading.done();
        var modalView = new ModalView({
          title: (parseInt(data.totalLengthMinutes) > 0) ?
            _.t('viewloopmodal.titel.minutes_and_seconds', { playerName: viewPlayerLoopModel.playerName, date: viewPlayerLoopModel.date, time: viewPlayerLoopModel.time, minutes: data.totalLengthMinutes, seconds: data.totalLengthSeconds }) :
            _.t('viewloopmodal.titel.seconds', { playerName: viewPlayerLoopModel.playerName, date: viewPlayerLoopModel.date, time: viewPlayerLoopModel.time, seconds: data.totalLengthSeconds }),
          modalContent: new ViewPlayerLoopModal({
            playlistItems: data.playlistItems
          }),
          bottom_toolbar: false
        });
        modalView.subViews.push(modalView.modal);
        modalView.open();
      });
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    }
  });

  return View;
});

